import React from 'react';
import { BaseCalendarProps, CalendarEvent } from './types';
import { EventChip } from './EventChip';

export interface AgendaViewProps extends BaseCalendarProps {
  from?: Date;
  to?: Date;
}

function sameDate(a: Date, b: Date) {
  return a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();
}

function groupByDay(events: CalendarEvent[]) {
  const groups = new Map<string, CalendarEvent[]>();
  for (const ev of events) {
    const key = new Date(ev.start.getFullYear(), ev.start.getMonth(), ev.start.getDate()).toISOString();
    const arr = groups.get(key) ?? [];
    arr.push(ev);
    groups.set(key, arr);
  }
  return Array.from(groups.entries())
    .map(([key, value]) => ({ day: new Date(key), events: value.sort((a, b) => a.start.getTime() - b.start.getTime()) }))
    .sort((a, b) => a.day.getTime() - b.day.getTime());
}

export const AgendaView: React.FC<AgendaViewProps> = ({ from, to, events, onEventClick }) => {
  const rangeFiltered = (events ?? []).filter((e) => {
    if (from && e.end < from) return false;
    if (to && e.start > to) return false;
    return true;
  });
  const grouped = groupByDay(rangeFiltered);
  return (
    <div className="bg-white border rounded-lg divide-y">
      {grouped.length === 0 && (
        <div className="p-3 text-sm text-muted-foreground">No events in this range</div>
      )}
      {grouped.map(({ day, events: dayEvents }) => (
        <div key={day.toISOString()} className="p-3">
          <div className="text-sm font-semibold mb-2">
            {day.toLocaleDateString(undefined, { weekday: 'short', month: 'short', day: 'numeric' })}
          </div>
          <div className="space-y-2">
            {dayEvents.map((ev) => (
              <EventChip key={ev.id} event={ev} onClick={onEventClick} />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};


